// extracted by mini-css-extract-plugin
export default {"large":"style_large__JMzaL","materialSymbolsRounded":"style_materialSymbolsRounded__hnuZ7","tiny":"style_tiny__zKKFo"};